export const WORK_RECORD_STATUS_FILTERS = [
  { value: "all", label: "All statuses", taskPrefix: "ALL" },
  { value: "pending", label: "Pending", taskPrefix: "PENDING" },
  { value: "in_progress", label: "In progress", taskPrefix: "IN PROGRESS" },
  { value: "completed_all", label: "Completed", taskPrefix: "COMPLETED" },
  { value: "completed", label: "Completed on time", taskPrefix: "ON-TIME" },
  { value: "late_start", label: "Late start", taskPrefix: "LATE START" },
  { value: "extra_time", label: "Extra time", taskPrefix: "EXTRA TIME" },
  { value: "delayed", label: "Delayed", taskPrefix: "DELAYED" },
  { value: "missing_checkout", label: "No checkout", taskPrefix: "NO CHECKOUT" },
  { value: "invalid", label: "Invalid", taskPrefix: "INVALID" },
] as const;

export type WorkRecordStatusFilter = (typeof WORK_RECORD_STATUS_FILTERS)[number]["value"];

export const workRecordStatusPrefix = (status: WorkRecordStatusFilter) =>
  WORK_RECORD_STATUS_FILTERS.find((option) => option.value === status)?.taskPrefix ?? "ALL";
